import { objectWithoutProperties as _objectWithoutProperties } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";

var DrawableCheckboxField = function DrawableCheckboxField(_ref) {
  var _assignmentStore$defa;

  var field = _ref.field,
      selected = _ref.selected,
      rest = _objectWithoutProperties(_ref, ["field", "selected"]);

  var _useStores = useStores(),
      assignmentStore = _useStores.assignmentStore;

  var isDefaultAssignmentType = field.data.assignedTo === ((_assignmentStore$defa = assignmentStore.defaultOption) === null || _assignmentStore$defa === void 0 ? void 0 : _assignmentStore$defa.assignmentKey);
  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  return jsx("g", rest, jsx("rect", {
    className: classnames({
      'bg-primary': isDefaultAssignmentType,
      'border-primary': isDefaultAssignmentType && selected,
      'bg-info': !isDefaultAssignmentType,
      'border-info': !isDefaultAssignmentType && selected
    }),
    fillOpacity: isDefaultAssignmentType ? '0.25' : '0.75',
    x: x,
    y: y,
    width: width,
    height: height
  }));
};

DrawableCheckboxField.displayName = "DrawableCheckboxField";
var DrawableCheckboxField$1 = observer(DrawableCheckboxField);
export default DrawableCheckboxField$1;